module.exports = __webpack_public_path__ + "static/media/logo.89d53ad1.jpg";